<ng-container *ngIf="userRoleId !== authService.ROLES.COORDINATOR && userRoleId !== authService.ROLES.B2C_ADMIN">
    <div class="patient-menu" *ngIf="type !== 'patient_profile'" [ngClass]="{ 'patient-menu--profile-page' : isProfile }">
        <div class="btn-group dropdown" dropdown *ngIf="type === 'active_patient'">
            <button class="btn btn-link dropdown-toggle--no-caret" [ngClass]="{ 'text-white' : isProfile }"
                    dropdownToggle>
                <i class="far fa-ellipsis-h" aria-hidden="true"></i>
            </button>
            <ul class="dropdown-menu dropdown-menu-right">
                <li class="dropdown-item" *ngIf="showSendReminderBtn(patient)" (click)="doAction('open_send_reminder')">
                    <a class="btn btn-link patient__icon">
                        <i class="patient__icon--fa send-reminder"></i>
                            {{ 'Send Reminder' | translate }}
                    </a>
                </li>
                <li class="dropdown-item" *ngIf="showOpenSeBtn(patient)" (click)="doAction('open_se')">
                    <a class="btn btn-link patient__icon">
                        <i class="patient__icon--fa open-self-report"></i>
                            {{ 'Open Self-report' | translate }}
                    </a>
                </li>
                <li class="dropdown-item" *ngIf="showExportMapBtn(patient)" (click)="doAction('export_map')">
                    <a class="btn btn-link patient__icon">
                        <i class="patient__icon--fa export-map"></i>
                            {{ 'Export Symptom map' | translate }}
                    </a>
                </li>
                <li class="dropdown-item" (click)="assign(patient.id)">
                    <a class="btn btn-link patient__icon">
                        <i class="patient__icon--fa transfer-patient"></i>
                        {{ 'Transfer patient' | translate }}
                    </a>
                </li>
                <li class="dropdown-item" *ngIf="appService.isDefaultClinic && patient.download_files && patient.download_files.length > 0" (click)="doAction('assign_to_pool')">
                    <a class="btn btn-link patient__icon">
                        <i class="patient__icon--fa transfer-patient"></i>
                        {{ 'Assign to Pool' | translate }}
                    </a>
                </li>
                <li class="dropdown-item" *ngIf="appService.isDefaultClinic && (userRoleId !== authService.ROLES.ASSISTANT && userRoleId !== authService.ROLES.ASSISTANT_PLUS)" (click)="doAction('open_contact_patient')">
                    <a class="btn btn-link patient__icon">
                        <i class="patient__icon--fa open-self-report"></i>
                        {{ 'Contact patient' | translate }}
                    </a>
                </li>
                <li class="dropdown-item" *ngIf="showOpenDiBtn(patient)" (click)="doAction('open_di')">
                    <a class="btn btn-link patient__icon">
                        <i class="patient__icon--fa open-di"></i>
                        {{ 'Open DI' | translate }}
                    </a>
                </li>
                <li class="divider dropdown-divider"></li>
                <li class="dropdown-item" (click)="marked(patient.id)">
                    <a class="btn btn-link ">
                        {{ 'Marking' | translate }}
                    </a>
                </li>
    
                <li class="dropdown-item" (click)="edit(patient.id)">
                    <a class="btn btn-link ">
                        {{ 'Edit' | translate }}
                    </a>
                </li>
    
                <li class="dropdown-item" (click)="openConfirm({
                    url: 'patients',
                    id: patient['id'],
                    action: 'archive',
                    title: 'Archive Patient',
                    content: 'Are you sure you want to archive patient?',
                    description: patient['surname'] + ' ' + patient['name'],
                    icon: 'fas fa-archive'
                })">
                    <a class="btn btn-link ">
                        {{ 'Archive' | translate }}
                    </a>
                </li>
                <li class="dropdown-item" (click)="openConfirm({
                    url: 'patients',
                    id: patient['id'],
                    action: 'delete',
                    title: 'Delete Patient Account',
                    content: 'Are you sure you want to delete patient?',
                    icon: 'far fa-trash-alt',
                    description: patient['surname'] + ', ' + patient['name']
                })">
                    <a class="btn btn-link text-danger">
                        {{ 'Delete' | translate }}
                    </a>
                </li>
            </ul>
        </div>
        <div class="btn-group dropdown" dropdown *ngIf="type === 'archived_patient'">
            <button class="btn btn-link dropdown-toggle--no-caret"
                    dropdownToggle>
                <i class="far fa-ellipsis-h" aria-hidden="true"></i>
            </button>
            <ul class="dropdown-menu dropdown-menu-right">
                <li class="dropdown-item" (click)="reactivate(patient.id)">
                    <a class="btn btn-link patient__icon">
                        <i class="patient__icon--fa reactivate"></i>
                        {{ 'Reactivate' | translate }}
                    </a>
                </li>
                <li class="dropdown-item" (click)="openConfirm({
                    url: 'patients',
                    id: patient['id'],
                    action: 'delete',
                    icon: 'far fa-trash-alt',
                    title: 'Delete Patient Account',
                    content: 'Are you sure you want to delete patient?',
                    description: patient['surname'] + ', ' + patient['name']
                })">
                    <a class="btn btn-link text-danger">
                        {{ 'Delete' | translate }}
                    </a>
                </li>
            </ul>
        </div>
    
    
        <div class="btn-group dropdown" dropdown *ngIf="type == 'deleted_patient'">
            <button  class="btn btn-link dropdown-toggle--no-caret"
                    dropdownToggle>
                <i class="far fa-ellipsis-h" aria-hidden="true"></i>
            </button>
            <ul class="dropdown-menu dropdown-menu-right">
                <li class="dropdown-item" (click)="openModal.emit({
                            url: 'patients',
                            id: patient['id'],
                            action: 'restore',
                            title: 'Restore Patient',
                            content: 'Are you sure you want to restore patient?',
                            description: patient['surname'] + ' ' + patient['name'],
                            icon: 'far fa-trash-restore-alt'
                        })">
                    <a class="btn btn-link patient__icon--restore">
                        <i class="far fa-trash-restore-alt" aria-hidden="true"></i>
                        {{ 'Restore ' | translate }}
                    </a>
                </li>
            </ul>
        </div>
    </div>
    <div *ngIf="type === 'patient_profile'">
        <ng-container *ngIf="authService.isAssistantPlus">
            <span class="patient__health-permission">{{ getPermissionStatus(patient['has_permission']) | translate }} </span>
            <span *ngIf="patient['has_permission'] === patientService.ACCESSSTATUS.NOACCESS || patient['has_permission'] === patientService.ACCESSSTATUS.DENIED" class="patient__icon" (click)="doAction('request_access')">
                {{'Request access' | translate}}
            </span>
            <span *ngIf="patient['has_permission'] === patientService.ACCESSSTATUS.GRANTED" class="patient__icon" (click)="doAction('request_access')">
                {{'Revoke access' | translate}}
            </span>
        </ng-container>
        <span tooltip="{{'Send Reminder' | translate}}" *ngIf="showSendReminderBtn(patient) && patient['has_permission'] === patientService.ACCESSSTATUS['GRANTED']" placement="bottom" class="patient__icon" (click)="doAction('open_send_reminder')">
            <i class="patient__icon--fa send-reminder patient-profile"></i>
        </span>
        <span tooltip="{{'Open Self-report' | translate}}" *ngIf="showOpenSeBtn(patient) && patient['has_permission'] === patientService.ACCESSSTATUS['GRANTED']" placement="bottom" class="patient__icon" (click)="doAction('open_se')">
            <i class="patient__icon--fa open-self-report patient-profile"></i>
        </span>
        <span tooltip="{{'Export Symptom map' | translate}}" *ngIf="showExportMapBtn(patient) && patient['has_permission'] === patientService.ACCESSSTATUS['GRANTED']" placement="bottom" class="patient__icon" (click)="doAction('export_map')">
            <i class="patient__icon--fa export-map patient-profile"></i>
        </span>
        <span tooltip="{{'Transfer patient' | translate}}" *ngIf="patient['has_permission'] === patientService.ACCESSSTATUS['GRANTED']" placement="bottom" class="patient__icon" (click)="assign(patient.id)">
            <i class="patient__icon--fa transfer-patient patient-profile"></i>
        </span>
        <span tooltip="{{'Open DI' | translate}}" *ngIf="showOpenDiBtn(patient) && patient['has_permission'] === patientService.ACCESSSTATUS['GRANTED']" placement="bottom" class="patient__icon"  (click)="doAction('open_di')">
            <i class="patient__icon--fa open-di patient-profile"></i>
        </span>
        <span class="patient-icon-divider">
            <div class="inner"></div>
        </span>
        <span tooltip="{{'Edit' | translate}}" placement="bottom" class="patient__icon" (click)="edit(patient.id)">
            <i class="patient__icon--fa  edit-patient patient-profile"></i>
        </span>
        <span tooltip="{{'Marking' | translate}}" placement="bottom" class="patient__icon" (click)="marked(patient.id)">
            <i class="patient__icon--fa add-marker patient-profile"></i>
        </span>
        <span tooltip="{{'Archive' | translate}}" placement="bottom" class="patient__icon" (click)="openConfirm({
            url: 'patients',
            id: patient['id'],
            action: 'archive',
            title: 'Archive Patient',
            content: 'Are you sure you want to archive patient?',
            description: patient['surname'] + ' ' + patient['name'],
            icon: 'fas fa-archive'
        })">
            <i class="patient__icon--fa  archive-patient patient-profile"></i>
        </span>
        <span tooltip="{{'Delete' | translate}}" placement="bottom" class="patient__icon" (click)="openConfirm({
            url: 'patients',
            id: patient['id'],
            action: 'delete',
            title: 'Delete Patient Account',
            content: 'Are you sure you want to delete patient?',
            icon: 'far fa-trash-alt',
            description: patient['surname'] + ', ' + patient['name']
        })">
            <i class="patient__icon--fa delete-patient patient-profile"></i>
        </span>
    </div>
</ng-container>
<ng-container *ngIf="userRoleId === authService.ROLES.COORDINATOR">
    <div class="patient-menu">
        <div class="btn-group dropdown" dropdown *ngIf="type === 'active_patient'">
            <button class="btn btn-link dropdown-toggle--no-caret"
                    dropdownToggle>
                <i class="far fa-ellipsis-h" aria-hidden="true"></i>
            </button>
            <ul class="dropdown-menu dropdown-menu-right">
                <li class="dropdown-item" *ngIf="showOpenSeBtnForCoordinator(patient)" (click)="doAction('open_se')">
                    <a class="btn btn-link patient__icon">
                        <i class="patient__icon--fa open-self-report"></i>
                            {{ 'Open Self-report' | translate }}
                    </a>
                </li>
                <li class="dropdown-item" (click)="assign(patient.id)">
                    <a class="btn btn-link patient__icon">
                        <i class="patient__icon--fa transfer-patient"></i>
                        {{ 'Transfer patient' | translate }}
                    </a>
                </li>
                <li class="dropdown-item" *ngIf="appService.isDefaultClinic && patient.download_files && patient.download_files.length > 0" (click)="doAction('coordinate_send_email')">
                    <a class="btn btn-link">
                        {{ 'Send email' | translate }}
                    </a>
                </li>
            </ul>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="userRoleId === authService.ROLES.B2C_ADMIN">
    <div class="patient-menu">
        <div class="btn-group dropdown" dropdown *ngIf="type === 'active_patient'">
            <button class="btn btn-link dropdown-toggle--no-caret"
                    dropdownToggle>
                <i class="far fa-ellipsis-h" aria-hidden="true"></i>
            </button>
            <ul class="dropdown-menu dropdown-menu-right">
                <li class="dropdown-item" (click)="doAction('generate_token')">
                    <a class="btn btn-link patient__icon">
                        <i class="fas fa-wrench"></i>
                        <span>{{ 'Generate token' | translate }}</span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</ng-container>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         